module.exports = __webpack_public_path__ + "static/stylelab_profile_edited_square.610e2f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/stylelab_profile_edited_square.png
// module id = 665
// module chunks = 168707334958949